<template>
	<div class="custom_vote_page">
		<success-popup v-if="showSuccessPage" />
		<need-login-popup v-if="showLoginStatus" />
	</div>
</template>

<script>
import NeedLoginPopup from '@/components/custom/needLoginPopup.vue';
import SuccessPopup from '@/components/custom/successPopup.vue';
import { mapState, mapActions } from 'vuex';
import { surveyAnswer, wxauth } from '@/services';
import { isWechat, isIos } from 'ourwill-feutil/common/ua';
import { wxConfig } from '@/utils/wxConfig';
import config from '@/config';
import shareLogo from '@/assets/img/question_logo.jpg';
export default {
	name: 'CustomPage',
	components: {
		NeedLoginPopup,
		SuccessPopup,
	},
	data() {
		return {
			showLoginStatus: false,
			isWechat: false,
			showSuccessPage: false,
		};
	},
	computed: {
		...mapState({
			userInfo: (state) => state.user.userInfo,
		}),
		isLogin() {
			return Boolean(this.userInfo && this.userInfo.id);
		},
	},
	mounted() {
		this.isWechat = isWechat(navigator.userAgent);
		this.initUser();
		setTimeout(() => {
			this.wechatShareInit();
		}, 1000);
	},
	methods: {
		...mapActions({
			getUserInfo: 'user/getUserInfo',
		}),
		async initUser() {
			const searchQuery = this.getSearchData(location.href);
			let obj = {};
			if (searchQuery && searchQuery.ticket) {
				obj.ticket = searchQuery.ticket;
			}
			await this.getUserInfo(obj);
			if (searchQuery && searchQuery.ticket) {
				const queryObj = JSON.parse(JSON.stringify(searchQuery));
				delete queryObj.ticket;
				this.$router.replace({
					name: this.$route.name,
					params: this.$route.params,
					query: queryObj,
				});
			} else {
				this.$nextTick(() => {
					this.initCustomLoginData();
				});
			}
		},
		async initCustomLoginData() {
			if (!this.isLogin) {
				// 说明当前未登录，判断一下当前的环境
				if (this.isWechat) {
					this.toWxAuth();
				} else {
					this.showNeedLoginPopup();
				}
			} else {
				// 说明已登录，但是未必有手机号信息
				if (!this.userInfo.mobPhone) {
					this.showNeedLoginPopup();
				} else {
					this.testUserCheck();
				}
			}
		},
		async testUserCheck() {
			try {
				const { data, ok } = await surveyAnswer.isAnswer(this.$route.params.id);
				if (!ok) {
					return;
				}
				if (data.data) {
					this.showSubmitSuccess();
				}
			} catch (error) {
				console.error(error);
			}
		},
		showNeedLoginPopup() {
			this.showLoginStatus = true;
		},
		showSubmitSuccess() {
			this.showSuccessPage = true;
		},
		getSearchData(href) {
			// 首先判断是否存在search内容;
			if (href && href.indexOf('?') !== -1) {
				// 首先解析href，将?后的内容取出
				const searchUrl = href.substring(href.indexOf('?') + 1);
				let obj = {};
				searchUrl.split('&').forEach((element) => {
					const list = element.split('=');
					if (list.length === 1) {
						// 说明不是准备的query数据
						return false;
					} else {
						// 判读当前的ticket内容是否存在#, 存在则说明回调地址拼接有误
						const ticket = list[1].indexOf('#') !== -1 ? list[1].replace(/#.*/, '') : list[1];
						obj[list[0]] = ticket;
					}
				});
				return obj;
			}
			return false;
		},
		toWxAuth() {
			wxauth();
		},
		async wechatShareInit() {
			// 分情况，需要判读一下，如果是在iframe中以及非微信环境，不执行
			if (
				window.self !== window.top ||
				(window.self && window.self.frameElement && window.self.frameElement.tagName === 'IFRAME') ||
				(window.parent && window.parent.frames.length !== window.frames.length) ||
				!this.isWechat
			) {
				return;
			}
			await wxConfig();
			this.wxShare();
		},
		// 初始化微信分享内容
		wxShare() {
			const wxInfo = {
				title: document.title, // 分享标题
				desc: '一分钟，一份问卷，一份改进。点击链接，让我们做得更好！',
				link: encodeURI(`${config.host}/questionnaire/#/questionnaireVote/${this.$route.params.id}/write`),
				imgUrl: shareLogo,
				trigger: (res) => {
					console.info('trigger', res);
				},
				success: () => {},
				fail: (err) => {
					console.error(err, 'try old share');
					this.doWxShareOld(this.wxInfo);
				},
			};
			this.doWxShare(wxInfo);
		},
		doWxShare(info) {
			const wx = this.$wx;
			wx.ready(() => {
				if (isIos(navigator.userAgent)) {
					wx.updateTimelineShareData(info);
					wx.updateAppMessageShareData(info);
					wx.onMenuShareWeibo(info);
				} else {
					this.doWxShareOld(info);
				}
			});
		},
		doWxShareOld(data) {
			const wx = this.$wx;
			const info = Object.assign({}, data, { fail: () => {} });
			wx.onMenuShareTimeline(info);
			wx.onMenuShareAppMessage(info);
			wx.onMenuShareQQ(info);
			wx.onMenuShareWeibo(info);
			wx.onMenuShareQZone(info);
		},
	},
};
</script>

<style lang="less"></style>
